import * as ko from "knockout";

export function registerSsoTips(): void {
    ko.bindingHandlers["ssoTips"] = {
        init(element: HTMLElement): void {
            const tipGap = 8;
            const placeTip = (host: Element, tip: HTMLElement): void => {
                tip.classList.remove("sso-tip--above");
                const hostRect = host.getBoundingClientRect();
                const tipHeight = tip.offsetHeight;
                const spaceBelow = window.innerHeight - hostRect.bottom;
                let clipBottom = window.innerHeight;
                for (let parent = host.parentElement; parent; parent = parent.parentElement) {
                    const style = getComputedStyle(parent);
                    if (style.overflow === "hidden" || style.overflowY === "hidden" || style.overflow === "auto" || style.overflowY === "auto" || style.overflow === "scroll" || style.overflowY === "scroll") {
                        clipBottom = Math.min(clipBottom, parent.getBoundingClientRect().bottom);
                    }
                    if (parent === document.body) {
                        break;
                    }
                }
                const spaceInClip = clipBottom - hostRect.bottom;
                if (Math.min(spaceBelow, spaceInClip) < tipHeight + tipGap) {
                    tip.classList.add("sso-tip--above");
                }
            };
            const apply = (node: Element): void => {
                const title = node.getAttribute("title");
                if (!title) {
                    return;
                }
                let tip = node.querySelector(":scope > .sso-tip");
                if (!(tip instanceof HTMLElement)) {
                    tip = document.createElement("span");
                    tip.className = "sso-tip";
                    tip.setAttribute("aria-hidden", "true");
                    node.appendChild(tip);
                }
                tip.textContent = title;
                node.classList.add("sso-has-tip");
                if (!node.getAttribute("aria-label")) {
                    node.setAttribute("aria-label", title);
                }
                node.removeAttribute("title");
                if (!(node as HTMLElement).dataset["ssoTipPlaced"]) {
                    (node as HTMLElement).dataset["ssoTipPlaced"] = "1";
                    const reposition = (): void => {
                        const current = node.querySelector(":scope > .sso-tip");
                        if (current instanceof HTMLElement) {
                            placeTip(node, current);
                        }
                    };
                    node.addEventListener("mouseenter", reposition);
                    node.addEventListener("focusin", reposition);
                }
            };
            const scan = (root: ParentNode): void => {
                if (root instanceof Element) {
                    apply(root);
                }
                root.querySelectorAll?.("[title]").forEach(node => apply(node));
            };
            scan(element);
            const observer = new MutationObserver(records => {
                records.forEach(record => {
                    if (record.type === "attributes" && record.target instanceof Element) {
                        apply(record.target);
                    }
                    record.addedNodes.forEach(node => {
                        if (node instanceof Element) {
                            scan(node);
                        }
                    });
                });
            });
            observer.observe(element, {subtree: true, childList: true, attributes: true, attributeFilter: ["title"]});
            ko.utils.domNodeDisposal.addDisposeCallback(element, () => observer.disconnect());
        },
    };
}
